var _line, _path, _path2, _line2, _line3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionarePrinRotire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.25,
    y1: 47,
    x2: 15.25,
    y2: 24,
    stroke: "black",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.25H16.5",
    stroke: "black",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H30.5",
    stroke: "black",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 35.25,
    x2: 41.5,
    y2: 35.25,
    stroke: "black",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 35.25,
    x2: 28.5,
    y2: 35.25,
    stroke: "black",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 35H54.5",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionarePrinRotire);
export default __webpack_public_path__ + "static/media/actionare_prin_rotire.b574d0f24bc7fc2cbf96767e9a64d46b.svg";
export { ForwardRef as ReactComponent };